"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

import { useAnalyticsConsent } from "@/components/analytics/AnalyticsProvider";
import { Button } from "@/components/ui/button";

export function ConsentBanner(): React.ReactElement | null {
  const { consent, setConsent } = useAnalyticsConsent();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(consent === null);
  }, [consent]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/95 backdrop-blur">
      <div className="mx-auto flex max-w-5xl flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="text-sm text-foreground">
          <p className="font-medium">Cookies &amp; analytics</p>
          <p className="mt-1 text-muted-foreground">
            We use essential cookies for sign-in. Analytics are optional and only run if you
            allow them.
            {" "}
            <Link href="/cookies" className="underline underline-offset-2 hover:text-foreground">
              Learn more
            </Link>
            .
          </p>
        </div>

        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => {
              setConsent("denied");
              setIsVisible(false);
            }}
          >
            Decline
          </Button>
          <Button
            onClick={() => {
              setConsent("granted");
              setIsVisible(false);
            }}
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}

